var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-full py-2 px-4 bouton openSans font-bold",class:{ 'white': _vm.white},attrs:{"type":"submit"}},[_vm._v("Connexion")])}
var staticRenderFns = []

export { render, staticRenderFns }